export default __webpack_public_path__ + "static/AbudulAziz-6282c9729b17d98f5ddcc4211d0687d8.png";